<template>
  <div class="rule-content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <svg-icon icon-class="rule" /> Rules
      </div>
      <el-tabs type="card">
        <el-tab-pane label="Main">
          <main-rules :projectUID="projectUID" :companyUID="companyUID"/>
        </el-tab-pane>
        <el-tab-pane label="Custom">
          <custom-rules :projectUID="projectUID" :companyUID="companyUID"/>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>

</template>

<script>
import MainRules from './components/rules-main'
import CustomRules from './components/rules-custom'
export default {
  props:{
    projectUID: String,
    companyUID: String
  },
  components: {
    MainRules,
    CustomRules
  },
}
</script>

<style>

</style>